export default __webpack_public_path__ + "static/media/graphql.be1dc316.svg";